// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export * from "./StorageBrowserPolicy-browser.mjs";
